/* eslint-disable jsx-a11y/alt-text */
import React, { useState, useEffect } from "react";
import axios from "axios";
import { useHistory, useParams } from "react-router-dom";
import TextAreaInput from "../UI/Input/TextAreaInput";
import Input from "../UI/Input/Input";
import PageTitle from "../UI/PageTitle";
import { endpoints } from "../../services/apiurl";
import { Button, Card } from "@mui/material";
import FileUploader from "../FileUploader";
import DeleteIcon from "@mui/icons-material/Delete";
import LoadingButton from "@mui/lab/LoadingButton";
import SaveIcon from "@mui/icons-material/Save";

const AppAbout = () => {
  let history = useHistory();
  let { id } = useParams();

  const [cat, setCat] = useState({
    heading: "",
    image: "",
    imageName: "",
    description: "",
  });
  const [selectedFile, setSelectedFile] = useState(null);
  const [loading, setloading] = useState(false);

  const { heading, image, imageName, description } = cat;
  const onInputChange = (e) => {
    setCat({ ...cat, [e.target.name]: e.target.value });
    // console.log(cat);
  };

  useEffect(() => {
    editcategory();
  }, []);

  const editcategory = async () => {
    await axios.post(endpoints.editAbout, { id: id }).then((response) => {
      setCat({
        id: response.data.data.id,
        heading: response.data.data.heading,
        description: response.data.data.description,
        image: response.data.data.image,
        imageName: response.data.data.imageName,
      });
      // console.log(response.data.data.cat_description)
    });
  };

  const removeImageHandler = async (id) => {
    await axios.post(endpoints.deleteImageAbout, { id }).then((response) => {});
    window.location.reload();
  };

  const onSubmit = async (e) => {
    setloading(true);
    e.preventDefault();
    const formData = new FormData();
    formData.append("heading", heading);
    formData.append("description", description);
    formData.append("image", selectedFile);
    formData.append("id", id);

    await axios.post(endpoints.updateAppAbout, formData).then((response) => {
      setloading(false);
      history.goBack();
    });
  };

  return (
    <div className="ui main">
      <PageTitle title="Edit Category" linkurl="" linkTitle="" />
      <Card className="px-3 py-3">
        <form
          className="ui form"
          onSubmit={(e) => onSubmit(e)}
          encType="multipart/form-data"
        >
          <div className="row">
            <Input
              id="heading"
              label="Heading"
              type="text"
              name="heading"
              place="heading"
              onChange={(e) => onInputChange(e)}
              requiredInput="true"
              value={heading}
              class="col col-6"
            />
          </div>
          <div className="row">
            <TextAreaInput
              id="description"
              label="Description"
              name="description"
              place="Discription"
              onChange={(e) => onInputChange(e)}
              requiredInput="required"
              value={description}
              class="col col-6"
            />

            <div className="col col-6">
              <label>Image</label>
              <FileUploader
                onFileSelectSuccess={(file) => setSelectedFile(file)}
                onFileSelectError={({ error }) => alert(error)}
              />

              {imageName ? (
                <div className="mt-3">
                  <img
                    src={image}
                    height="200px"
                    width="200px"
                    className="px-2"
                  />
                  <Button
                    variant="outlined"
                    color="error"
                    startIcon={<DeleteIcon />}
                    onClick={() => removeImageHandler(id)}
                  >
                    Delete
                  </Button>
                </div>
              ) : (
                ""
              )}
            </div>
          </div>

          <div className="row">
            <div className="col col-6">
              <div className="mt-3">
                <LoadingButton
                  type="submit"
                  loading={loading}
                  loadingPosition="start"
                  startIcon={<SaveIcon />}
                  variant="contained"
                  size="large"
                >
                  Save
                </LoadingButton>
              </div>
            </div>
          </div>
        </form>
      </Card>
    </div>
  );
};

export default AppAbout;
